import { Slot } from '@radix-ui/react-slot';
import type { ComponentPropsWithoutRef } from 'react';
import { cn } from '@/lib/utils';

type PageContainerProps = ComponentPropsWithoutRef<'div'> & {
    /** Apply the container to an existing element without adding a wrapper. */
    asChild?: boolean;
    /** Centered page, start-aligned tabs, uncapped gutter, or unstyled canvas. */
    layout?: 'centered' | 'start' | 'full' | 'bleed';
};

/** Shared horizontal geometry; callers own their vertical spacing and contents. */
export function PageContainer({
    asChild = false,
    layout = 'centered',
    className,
    ...props
}: PageContainerProps) {
    const Component = asChild ? Slot : 'div';

    return (
        <Component
            className={cn(
                // 8px rail allowance + 32px sidebar toggle + 8px breadcrumb gap.
                layout !== 'bleed' && 'w-full px-12',
                (layout === 'centered' || layout === 'start') && 'max-w-[1320px]',
                layout === 'centered' && 'mx-auto',
                className
            )}
            {...props}
        />
    );
}
